import platform from "../../../util/platform";
const create = (module) => {
    return (params) => {
        const path = `/content/modules/create`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, module);
    };
};
const createRevision = (module) => {
    return (params) => {
        const path = `/content/modules/create/revision`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, module);
    };
};
const update = (module) => {
    return (params) => {
        const path = `/content/modules/update`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, module);
    };
};
const clone = (moduleId, newName) => {
    return (params) => {
        const path = `/content/modules/${moduleId}/clone/${newName}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const deleteModule = (moduleId) => {
    return (params) => {
        const path = `/content/module/${moduleId}/delete`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const getById = (moduleId) => {
    return (params) => {
        const path = `/content/module/id/${moduleId}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getAll = () => {
    return (params) => {
        const path = `/content/module`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getOverview = () => {
    return (params) => {
        const path = `/content/modules/overviews`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getRecentOverviews = () => {
    return (params) => {
        const path = `/content/modules/overviews/recent`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const modules = {
    create,
    createRevision,
    update,
    clone,
    deleteModule,
    getById,
    getAll,
    getOverview,
    getRecentOverviews,
};
export default modules;
